module.exports = __webpack_public_path__ + "img/arm-header-icons-04.c535a5c5.svg";